import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/header/mspc_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0a06e401"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "routerList" }
const _hoisted_4 = {
  key: 0,
  class: "miniTips"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "登录/注册")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "loginPart"
}
const _hoisted_8 = { class: "loginFnList" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "套餐", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "站内信", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "downList" }
const _hoisted_13 = { class: "downList" }
const _hoisted_14 = { class: "downIcon" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "downTitle" }
const _hoisted_18 = { class: "downList" }
const _hoisted_19 = { class: "downIcon" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "downTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", null, [
        _hoisted_2,
        _createElementVNode("nav", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerArr, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: _normalizeClass(['routerItem', { activeItem: item.name == _ctx.routerName }]),
              to: item.url,
              onMouseenter: ($event: any) => (_ctx.mouseOver(index)),
              onMouseleave: ($event: any) => (_ctx.mouseleave(index)),
              key: index
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title) + " ", 1),
                (item.tips)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(item.tips), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class", "to", "onMouseenter", "onMouseleave"]))
          }), 128))
        ]),
        (!_ctx.userInfo['userId'])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "loginBtn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleDialog('login', true)))
            }, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: { name: 'payRecord' },
                  class: "toggleBtn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'messageList' },
                  class: "toggleBtn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createElementVNode("span", {
                  onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mouseOver(7))),
                  onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mouseleave(7)))
                }, "工单", 32),
                _createVNode(_component_el_dropdown, { onCommand: _ctx.handleCommand }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { command: "a" }, {
                          default: _withCtx(() => [
                            _createTextVNode("账户信息")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "l" }, {
                          default: _withCtx(() => [
                            _createTextVNode("退出登录")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "userIcon",
                      src: _ctx.userInfo['avatarUrl'],
                      alt: ""
                    }, null, 8, _hoisted_11)
                  ]),
                  _: 1
                }, 8, ["onCommand"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['downMenu', 'workOrder', { show: _ctx.isDown[7] }])
              }, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerList3, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "downItem",
                      key: index
                    }, [
                      _createVNode(_component_router_link, {
                        to: { name: item.url },
                        class: "downTitle"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ], 2)
            ]))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['downMenu', { show: _ctx.isDown[1] }])
      }, [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerList, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: { name: item.url },
              class: "downItem",
              key: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    class: "icon rIcon",
                    src: item.iconUrl,
                    alt: ""
                  }, null, 8, _hoisted_15),
                  _createElementVNode("img", {
                    class: "icon wIcon",
                    src: item.iconUrl2,
                    alt: ""
                  }, null, 8, _hoisted_16)
                ]),
                _createElementVNode("p", _hoisted_17, _toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(['downMenu', { show: _ctx.isDown[2] }])
      }, [
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerList2, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: { name: item.url },
              class: "downItem",
              key: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    class: "icon rIcon",
                    src: item.iconUrl,
                    alt: ""
                  }, null, 8, _hoisted_20),
                  _createElementVNode("img", {
                    class: "icon wIcon",
                    src: item.iconUrl2,
                    alt: ""
                  }, null, 8, _hoisted_21)
                ]),
                _createElementVNode("p", _hoisted_22, _toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ], 2)
    ]),
    _createVNode(_component_LoginDialog, {
      type: _ctx.type,
      isShow: _ctx.isShow,
      onToggleDialog: _ctx.toggleDialog
    }, null, 8, ["type", "isShow", "onToggleDialog"])
  ], 64))
}